import styled from "@emotion/styled"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faLongArrowAltRight,
} from "@fortawesome/free-solid-svg-icons"
import React from "react"
import tw from "twin.macro"
import fullConfig from "../utils/tailwindConfig"

library.add(
  faLongArrowAltRight,
)

export const BaseButton = styled.a`
  ${tw`inline-block text-white font-bold uppercase px-4 py-3 transition-colors duration-300 ease-in-out rounded max-w-full text-center leading-normal`}
  ${(props) =>
    (props.contrastText && tw`bg-black hover:bg-blue`) ||
    tw`bg-blue hover:bg-black`}
  ${(props) => (props.size === "lg" ? tw`py-4 px-6 text-lg` : tw`py-3`)}
  ${(props) =>
    props.isDisabled ? tw`bg-gray-light hover:bg-gray-light text-black` : tw``}
  ${(props) =>
    props.isDisabled
      ? `
    cursor: not-allowed;
  `
      : tw``}
  [aria-disabled="true"] {
    pointer-events: none;
  }
`

const ButtonUnderline = styled.a`
  font-weight: bold;
  text-transform: uppercase;
  padding: 20px;
  position: relative;
  padding: 0;
  border: 0;
  background-color: transparent;
  display: inline-block;
  ${(props) => ({
    color: props.contrastText
      ? fullConfig.theme.colors.white.DEFAULT
      : fullConfig.theme.colors.gray.DEFAULT,
  })}
  span {
    display: block;
    padding: 10px 12px;
  }
  &::before,
  &::after {
    content: "";
    width: 0;
    height: 1px;
    position: absolute;
    transition: all 0.15s linear;
    ${(props) => ({
      backgroundColor: props.contrastText
        ? fullConfig.theme.colors.white.DEFAULT
        : fullConfig.theme.colors.gray.DEFAULT,
    })}
  }
  span::before,
  span::after {
    content: "";
    width: 1px;
    height: 0;
    position: absolute;
    transition: all 0.15s linear;
    ${(props) => ({
      backgroundColor: props.contrastText
        ? fullConfig.theme.colors.white.DEFAULT
        : fullConfig.theme.colors.gray.DEFAULT,
    })}
  }
  &:hover::before {
    width: 100%;
  }
  &:hover span::before,
  &:hover span::after {
    height: 100%;
  }
  &::after {
    width: calc(100% - 16px);
    left: 8px;
    bottom: 0;
    transition-delay: 0.45s;
  }
  & span::after {
    transition-delay: 0.3s;
    right: 0;
    bottom: 0;
  }
  &::before {
    right: 0;
    top: 0;
    transition-delay: 0.15s;
  }
  & span::before {
    transition-delay: 0s;
    left: 0;
    top: 0;
  }
  &:hover::after {
    transition-delay: 0s;
    width: 100%;
    left: 0;
  }
  &:hover span::after {
    transition-delay: 0.15s;
  }
  &:hover::before {
    transition-delay: 0.3s;
  }
  &:hover span::before {
    transition-delay: 0.45s;
  }
`

const Button = ({
  text,
  type,
  children,
  contrastText,
  size,
  icon,
  as,
  ...other
}) => {
  if (type === "underline") {
    return (
      <ButtonUnderline as={as} contrastText={contrastText} {...other}>
        <span>{children}</span>
      </ButtonUnderline>
    )
  } else {
    return (
      <BaseButton as={as} contrastText={contrastText} size={size} {...other}>
        {children}
        {icon ? ` ` : ``}
        {icon ? <FontAwesomeIcon icon={["fas", icon]} /> : ``}
      </BaseButton>
    )
  }
}

export default Button
